import { useState } from 'react';
import EyeIcon from 'assets/eye-icon.svg';
import EyeSlashIcon from 'assets/eye-slash-icon.svg';

import { CopyToClipboardIcon } from 'components/CopyToClipboardIcon';

import { Input, InputProps } from '../Input';

import classes from './style.module.css';

interface ShowPasswordInputProps extends Omit<InputProps, 'type'> {
  showCopyClipboard?: boolean; // show copy to clipboard icon
}

export const ShowPasswordInput: React.FC<ShowPasswordInputProps> = ({ showCopyClipboard, ...props }) => {
  const [showPassword, setShowPassword] = useState(false);
  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className={classes.passwordInputContainer}>
      <Input
        {...props}
        style={{ width: '100%', paddingRight: showCopyClipboard ? '4rem' : '3rem' }}
        type={showPassword ? 'text' : 'password'}
      />
      {showCopyClipboard && (
      <div className={classes.copyButton}>
        <CopyToClipboardIcon textToCopy={props.value?.toString() || ''} />
      </div>
      )}
      <div
        role="button"
        tabIndex={0}
        onKeyDown={handleTogglePassword}
        className={classes.passwordToggleButton}
        onClick={handleTogglePassword}
      >
        {showPassword ? <img src={EyeSlashIcon} alt="hide" /> : <img src={EyeIcon} alt="show" />}
      </div>
    </div>
  );
};
